<div class="title">
  @if (objectClassId === NomObjectClass.USER) {
    <img class="img" [src]="avatarUrl" [appFallbackImage]="avatarFallback" />
  }
  <a
    class="object-title"
    [class.object-title--link]="isClickable"
    (click)="onClick()"
    [suiTooltip]="tooltip"
  >
    @if (icon && title) {
      <fa-icon [icon]="icon"></fa-icon>
    }
    <span>{{ title }}</span>
  </a>
  @if (hasMenu) {
    <div class="dropdown-cell" (click)="toggleDropdown($event)">
      <a
        ><fa-icon
          [icon]="['fas', 'bars']"
          [class.active]="dropdownVisible"
        ></fa-icon
      ></a>
      <div #cardDropdownContainer></div>
    </div>
  }
</div>

@if (!title && !avatarUrl) {
  <span class="sensika-cell--empty" [suiTooltip]="emptyTooltip">{{
    placeholder
  }}</span>
}
